// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dialog-body-scrollable {\n  height: calc(100% - 180px);\n}\n\noperator-selection-list, .list-wrapper {\n  height: calc(80% - 20px);\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
